import { forwardRef } from "react";
import cn from "classnames";
import { ArrowRightShortIcon, LinkIcon, TrashIcon } from "shared/ui/Icons";
import { Button, ButtonProps } from "./Button";
import styles from "./Button.module.scss";

type IconVariant = "trash" | "arrow-right" | "link";
type ButtonIconProps = Omit<ButtonProps, "variant"> & {
  icon?: IconVariant;
};

const iconMap: Record<IconVariant, JSX.Element> = {
  trash: <TrashIcon />,
  "arrow-right": <ArrowRightShortIcon />,
  link: <LinkIcon />,
} as const;

export const ButtonIcon = forwardRef<HTMLButtonElement, ButtonIconProps>((props, ref) => {
  const { icon, className, children, ...resetComponentProps } = props;
  const _children = icon && icon in iconMap ? iconMap[icon] : children;

  return (
    <Button ref={ref} className={cn(styles["button-icon"], icon && styles[icon], className)} {...resetComponentProps}>
      {_children}
    </Button>
  );
});

ButtonIcon.displayName = "ButtonIcon";
